import Vue from 'vue';
import VueRouter from 'vue-router';

import Layout from '@/layout';
import cookies from 'vue-cookies'
import { Message, MessageBox } from 'element-ui';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Layout,
    // redirect: 'main',
    children: [{
      path: 'hold',
      name: 'Hold',
      meta: {
        title: '预约'
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/hold/index.vue'),
    }, {
      path: 'hold-list',
      name: 'HoldList',
      meta: {
        title: '我的预约'
      },
      component: () => import('../views/hold-list/index.vue'),
    }, {
      path: 'main',
      name: 'main',
      meta: {
        title: '个人中心'
      },
      component: () => import('../views/main/index.vue'),
    }, {
      path: 'loan',
      name: 'loan',
      meta: {
        title: '我的借阅'
      },
      component: () => import('../views/loan/index.vue'),
    }, {
      path: 'loan-history',
      name: 'loan-history',
      meta: {
        title: '借阅历史'
      },
      component: () => import('../views/loan-history/index.vue'),
    }, {
      path: 'savings',
      name: 'savings',
      meta: {
        title: '我的收藏'
      },
      component: () => import('../views/savings/index.vue'),
    }, {
      path: 'info',
      name: 'info',
      meta: {
        title: '个人信息'
      },
      component: () => import('../views/info/index.vue'),
    }]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: '/portal/',
  routes,
});

/**
router.beforeEach(async (to, from, next) => {
  document.title = `${to.meta.title} -北京大学图书馆`;
  next();
});
**/

router.beforeEach(async (to, from, next) => {
  document.title = `${to.meta.title} -北京大学图书馆`;
  var oneStopWebToken = to.query.code;
  if(cookies.get('code') && to.path != "/"){
    if(oneStopWebToken != null){
      cookies.set('code', oneStopWebToken, { path: '/', domain: 'lib.pku.edu.cn' });
    }
    next();
  } else if(cookies.get('code') && to.path == "/"){
    window.location.replace('https://sso.lib.pku.edu.cn/oauth/authorize?client_id=oneStopWeb&redirect_uri=https://a.lib.pku.edu.cn:8443/sso/login&response_type=code&state=PCReaderOAuth');
  } else if(oneStopWebToken && to.path == "/main"){
    cookies.set('code', oneStopWebToken, { path: '/', domain: 'lib.pku.edu.cn' });
    next({
      path: '/main',
      query: {}
    });
  } else {
    /*
    Message.warning('请在校内网或者登录VPN后尝试重新访问。');
    setTimeout(function () {
      // 等待1秒后跳转
      window.location.replace('https://sso.lib.pku.edu.cn/oauth/authorize?client_id=oneStopWeb&redirect_uri=https://a.lib.pku.edu.cn:8443/sso/login&response_type=code&state=PCReaderOAuth');
    }, 1000);*/
    let time = 10;
    let timer;
    document.title = `个人中心 -北京大学图书馆`;
    timer = setInterval(() => {
      time--;
      document.getElementById('timed').innerHTML = time;//实现动态渲染
      if (time == 0) {
        clearInterval(timer);//如果到0清除倒计时
        window.location.replace('https://sso.lib.pku.edu.cn/oauth/authorize?client_id=oneStopWeb&redirect_uri=https://a.lib.pku.edu.cn:8443/sso/login&response_type=code&state=PCReaderOAuth');
        document.getElementById('timed').innerHTML = 10;//重新赋为10秒
        MessageBox.close(false);//关闭弹窗
      }
    }, 1000);//进行倒计时
    MessageBox.alert(
      `<div>目前仅支持校内网访问，校外网请登录北大VPN后访问。系统将在<span id='timed' style='color: #06B7AE'>10</span>s或点击确定后跳转</div>`,
      '校内访问提示',
      {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        closeOnClickModal: false,
        callback: action => {
          clearInterval(timer);//如果点击清除倒计时
          window.location.replace('https://sso.lib.pku.edu.cn/oauth/authorize?client_id=oneStopWeb&redirect_uri=https://a.lib.pku.edu.cn:8443/sso/login&response_type=code&state=PCReaderOAuth');
          document.getElementById('timed').innerHTML = 10;//重新赋为30秒
        }
      }
    )
    //window.location.replace('https://sso.lib.pku.edu.cn/oauth/authorize?client_id=oneStopWeb&redirect_uri=https://a.lib.pku.edu.cn:8443/sso/login&response_type=code&state=PCReaderOAuth');
  }
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;
